export const environment = {
  production: false,
  nonce: '09953c6c9fe06ae141392dd95ba0a7c4',
  apiURL: 'https://dev.ffm.eskspatial.com.au/api/',
  taskURL: 'https://dev.ffm.eskspatial.com.au/tasks'
};
